import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" briefing.sqf ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Tout supprimer ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Cette action supprimera toute les données et est irréversible, voulez-vous continuer ? ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" (un rechargemnt de la page est parfois nécéssaire pour voir les changements) ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Download = _resolveComponent("Download")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_CaretDown = _resolveComponent("CaretDown")!
  const _component_n_dropdown = _resolveComponent("n-dropdown")!
  const _component_n_button_group = _resolveComponent("n-button-group")!
  const _component_Times = _resolveComponent("Times")!
  const _component_n_popconfirm = _resolveComponent("n-popconfirm")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_code = _resolveComponent("n-code")!
  const _component_n_card = _resolveComponent("n-card")!

  return (_openBlock(), _createBlock(_component_n_space, { vertical: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_n_space, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_button_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_n_button, {
                ghost: "",
                type: "primary",
                onClick: _ctx.downloadBriefing
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_n_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Download)
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_n_dropdown, {
                trigger: "hover",
                options: _ctx.options,
                "render-label": _ctx.renderDropdownLabel
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_button, {
                    ghost: "",
                    type: "primary",
                    style: {"padding":"6px"}
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_n_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_CaretDown)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["options", "render-label"])
            ]),
            _: 1
          }),
          _createVNode(_component_n_popconfirm, {
            "show-icon": false,
            "negative-text": null,
            onPositiveClick: _ctx.clearData
          }, {
            activator: _withCtx(() => [
              _createVNode(_component_n_button, {
                type: "error",
                ghost: ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_n_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Times)
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onPositiveClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_n_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_code, {
            code: _ctx.sqf,
            language: "sqf"
          }, null, 8, ["code"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}